export default __webpack_public_path__ + "6522599db96b93ca8e4d719584ec5e9d.jpg";